var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrops(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 20.375C11.5 20.375 13.75 18.0875 13.75 15.3125C13.75 13.8625 13.0375 12.4875 11.6125 11.325C10.1875 10.1625 9.1125 8.4375 8.75 6.625C8.3875 8.4375 7.325 10.175 5.8875 11.325C4.45 12.475 3.75 13.875 3.75 15.3125C3.75 18.0875 6 20.375 8.75 20.375Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6998 8.2499C16.5595 6.87631 17.1689 5.36121 17.4998 3.7749C18.1248 6.8999 19.9998 9.8999 22.4998 11.8999C24.9998 13.8999 26.2498 16.2749 26.2498 18.7749C26.2569 20.5028 25.7509 22.1938 24.7958 23.6338C23.8407 25.0737 22.4796 26.1976 20.885 26.863C19.2904 27.5284 17.5341 27.7054 15.8388 27.3715C14.1435 27.0376 12.5855 26.2078 11.3623 24.9874",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrops);
export default __webpack_public_path__ + "static/media/drops.c908f8456592808c03e28a25cd708ee4.svg";
export { ForwardRef as ReactComponent };